import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=c1e0e8fe&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1e0e8fe')) {
      api.createRecord('c1e0e8fe', component.options)
    } else {
      api.reload('c1e0e8fe', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=c1e0e8fe&", function () {
      api.rerender('c1e0e8fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4WYqt2giWG0HR/JS/comp/IncreaseNumber.vue"
export default component.exports